import type { BadgeColors } from "./badge-types";

export const filledColors: Record<
	BadgeColors,
	{ addon: string; addonButton: string; root: string }
> = {
	blue: {
		addon: "text-utility-blue-500",
		addonButton:
			"hover:bg-utility-blue-100 text-utility-blue-400 hover:text-utility-blue-500",
		root: "bg-utility-blue-50 text-utility-blue-700 ring-utility-blue-200",
	},
	brand: {
		addon: "text-utility-brand-500",
		addonButton:
			"hover:bg-utility-brand-100 text-utility-brand-400 hover:text-utility-brand-500",
		root: "bg-utility-brand-50 text-utility-brand-700 ring-utility-brand-200",
	},
	error: {
		addon: "text-utility-red-800",
		addonButton:
			"hover:bg-utility-red-100 text-utility-red-400 hover:text-utility-red-500",
		root: "bg-utility-red-900 text-utility-red-800 ring-utility-red-950",
	},
	gray: {
		addon: "text-utility-neutral-500",
		addonButton:
			"hover:bg-utility-neutral-100 text-utility-neutral-400 hover:text-utility-neutral-500",
		root: "bg-utility-neutral-50 text-utility-neutral-700 ring-utility-neutral-200",
	},
	indigo: {
		addon: "text-utility-indigo-500",
		addonButton:
			"hover:bg-utility-indigo-100 text-utility-indigo-400 hover:text-utility-indigo-500",
		root: "bg-utility-indigo-50 text-utility-indigo-700 ring-utility-indigo-200",
	},
	orange: {
		addon: "text-utility-orange-500",
		addonButton:
			"hover:bg-utility-orange-100 text-utility-orange-400 hover:text-utility-orange-500",
		root: "bg-utility-orange-50 text-utility-orange-700 ring-utility-orange-200",
	},
	pink: {
		addon: "text-utility-pink-500",
		addonButton:
			"hover:bg-utility-pink-100 text-utility-pink-400 hover:text-utility-pink-500",
		root: "bg-utility-pink-50 text-utility-pink-700 ring-utility-pink-200",
	},
	purple: {
		addon: "text-utility-purple-500",
		addonButton:
			"hover:bg-utility-purple-100 text-utility-purple-400 hover:text-utility-purple-500",
		root: "bg-utility-purple-50 text-utility-purple-700 ring-utility-purple-200",
	},
	sky: {
		addon: "text-utility-sky-500",
		addonButton:
			"hover:bg-utility-sky-100 text-utility-sky-400 hover:text-utility-sky-500",
		root: "bg-utility-sky-50 text-utility-sky-700 ring-utility-sky-200",
	},
	slate: {
		addon: "text-utility-slate-500",
		addonButton:
			"hover:bg-utility-slate-100 text-utility-slate-400 hover:text-utility-slate-500",
		root: "bg-utility-slate-50 text-utility-slate-700 ring-utility-slate-200",
	},
	success: {
		addon: "text-utility-success-500",
		addonButton:
			"hover:bg-utility-success-100 text-utility-success-400 hover:text-utility-success-500",
		root: "bg-utility-success-50 text-utility-success-700 ring-utility-success-200",
	},
	warning: {
		addon: "text-utility-warning-500",
		addonButton:
			"hover:bg-utility-warning-100 text-utility-warning-400 hover:text-utility-warning-500",
		root: "bg-utility-warning-50 text-utility-warning-700 ring-utility-warning-200",
	},
	watchlist: {
		addon: "text-white",
		addonButton: "hover:bg-utility-red-100 text-white hover:text-white",
		root: "bg-utility-red-700 text-white ring-utility-red-700 dark:ring-utility-red-200 dark:bg-utility-red-200",
	},
};

/**
 * Domain status / decision / source values → Untitled badge palette.
 * Unknown values fall back to gray via {@link statusBadgeColor}.
 */
export const statusToneColors: Record<string, BadgeColors> = {
	alertNow: "brand",
	applied: "brand",
	completed: "success",
	confirmed: "success",
	customerEdit: "brand",
	drafting: "gray",
	escalate: "brand",
	failed: "error",
	forced: "warning",
	lowPriorityLog: "gray",
	noChange: "gray",
	notConfirmed: "gray",
	pending: "gray",
	queued: "gray",
	rejected: "gray",
	reverted: "gray",
	reviewQueue: "gray",
	running: "blue",
	skipped: "gray",
	superseded: "gray",
};

/** Resolve a domain status string to a badge color (unknown → gray). */
export const statusBadgeColor = (value: string): BadgeColors =>
	statusToneColors[value] ?? "gray";
